{
  "eyebrow": "OUR DREAM",
  "title": "An empowerment hub for the student economy.",
  "body": "By sharing resources between students we lower costs, widen access and give students confidence, tools and opportunities."
}
